import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  BoundaryZoomLevelDisclaimerModalComponent, type BoundaryZoomLevelDisclaimerProps,
} from './boundaryZoomLevelDisclaimerModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    BoundaryZoomLevelDisclaimer: BoundaryZoomLevelDisclaimerProps;
  }
}
modalRenderer.register('BoundaryZoomLevelDisclaimer', BoundaryZoomLevelDisclaimerModalComponent);
